<script setup>
import HostNameInput from '@/Components/Input/HostNameInput.vue';
import InputDescription from '@/Components/Input/InputDescription.vue';
import { Link } from '@inertiajs/vue3';
import { computed, reactive } from 'vue';

const props = defineProps({
  modelValue: String,
  errorMessage: {
    type: [String, Boolean],
    default: null
  },
  redirectTo: {
    type: String,
    required: true
  }
});

const state = reactive({
  domainName: props.modelValue
});

const domainName = computed(() => props.modelValue.replace(/^www\./, ''));

const containsWww = computed(() => {
  return (
    props.modelValue.toLowerCase().startsWith('www.') &&
    props.modelValue.length > 5
  );
});

const variant = computed(() => {
  if (props.errorMessage !== null) {
    return 'danger';
  }
  return containsWww.value ? 'warning' : 'default';
});
</script>

<template>
  <div class="flex flex-col">
    <HostNameInput
      id="domain"
      :label="$t('common.domain_input.domain_name')"
      v-model.trim.lazy="state.domainName"
      size="large"
      clearable
      autofocus
      v-bind="$attrs"
      :variant="variant"
    />
    <InputDescription :variant="variant">
      <div v-if="errorMessage !== null">
        {{ errorMessage }}
      </div>
      <i18n-t
        v-else-if="containsWww"
        keypath="common.domain_input.subdomain_change"
        tag="div"
        for="link"
      >
        <template #link>
          <Link
            :href="route(redirectTo, domainName)"
            class="text-primary-600 hover:text-primary-500 underline"
          >
            {{ domainName }}
          </Link>
        </template>
      </i18n-t>
      <div class="text-tertiary-content" v-else>
        {{ $t('common.domain_input.domain_example') }}
      </div>
    </InputDescription>
  </div>
</template>
